import tools from "../../../../helpers/tools";

export const DateDebut = ({ dateDebut }) => {
  return (
    <div className="d-flex align-items-center" style={{ gap: 5 }}>
      <i className="fa fa-calendar-day text-primary" style={{ fontSize: 12 }} />
      <span>{tools.formatDate(dateDebut) || "-"}</span>
    </div>
  );
};

export const DateFin = ({ dateFin }) => {
  return (
    <div className="d-flex align-items-center" style={{ gap: 5 }}>
      <i
        className="fa fa-calendar-check text-success"
        style={{ fontSize: 12 }}
      />
      <span>{tools.formatDate(dateFin) || "-"}</span>
    </div>
  );
};

const PeriodContratCell = ({ item }) => {
  return (
    <div className="d-flex flex-column align-items-center">
      <div className="d-flex align-items-center" style={{ gap: 5 }}>
        <i
          className="fa fa-calendar-day text-primary"
          style={{ fontSize: 12 }}
        />
        <span>{tools.formatDate(item.contrat?.date_debut) || "-"}</span>
      </div>
      <div className="d-flex align-items-center" style={{ gap: 5 }}>
        <i
          className="fa fa-calendar-check text-success"
          style={{ fontSize: 12 }}
        />
        <span>{tools.formatDate(item.contrat?.date_fin_prevue) || "-"}</span>
      </div>
    </div>
  );
};

export default PeriodContratCell;
